import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellAttributesSizeS from './IconWellAttributes_size_s';

const props: CreateIconArguments = {
  l: IconWellAttributesSizeS,
  m: IconWellAttributesSizeS,
  s: IconWellAttributesSizeS,
  xs: IconWellAttributesSizeS,
  name: 'IconWellAttributes',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
